import { createPortal } from 'react-dom';
import { NoSSR } from './no-ssr.js';
import { jsx } from 'react/jsx-runtime';

/**
 * portals needs to interact with the dom to actually mount in the target where
 * they are needed. This isn't possible during SSR.
 *
 * As such this component aims to create portals that does not trigger
 * hydration issues as they will only ever render on the clientside AFTER the
 * initial mount has been completed.
 */
function IsomorphicPortal(props) {
  if (typeof document === "undefined") {
    return null;
  }
  return /*#__PURE__*/jsx(NoSSR, {
    children: /*#__PURE__*/createPortal(props.children, (props.target && "current" in props.target ? props.target.current : props.target) || document.body)
  });
}

export { IsomorphicPortal };
//# sourceMappingURL=isomorphic-portal.js.map
